// extracted by mini-css-extract-plugin
module.exports = {"Root":"AppContainer_Root__3Vptn","AbsoluteWrapper":"AppContainer_AbsoluteWrapper__1E9fI","Content":"AppContainer_Content__3Jp9D"};